import { useEffect, useRef, useState } from 'react';
import { getLookupPage } from '../api';
import { toLookupOption } from '../components/lookupOption';

const PAGE_SIZE = 25;
export default function useLookupOptions(source) {
    const [search, setSearch] = useState('');
    const [query, setQuery] = useState({ search: '', page: 0, attempt: 0 });
    const [state, setState] = useState({ options: [], total: 0, loading: true, error: '' });
    const pending = useRef(true);
    useEffect(() => {
        pending.current = true;
        setState({ options: [], total: 0, loading: true, error: '' });
        const timer = setTimeout(() => setQuery({ search, page: 0, attempt: 0 }), 250);
        return () => clearTimeout(timer);
    }, [search]);
    useEffect(() => {
        if (query.search !== search) return;
        const controller = new AbortController();
        let current = true;
        pending.current = true;
        setState(previous => ({ ...previous, loading: true, error: '' }));
        getLookupPage(source, { pageIndex: query.page, pageSize: PAGE_SIZE, search: query.search, sortBy: 'Name', sortDirection: 'asc' }, controller.signal)
            .then(({ items, total }) => {
                if (!current) return;
                const options = items.map(item => toLookupOption(item));
                setState(previous => ({
                    options: Array.from(new Map([...(query.page ? previous.options : []), ...options].map(option => [String(option.value), option])).values()),
                    total, loading: false, error: '',
                }));
            }).catch(error => { if (current) setState(previous => ({ ...previous, loading: false, error: error.message })); })
            .finally(() => { if (current) pending.current = false; });
        return () => { current = false; controller.abort(); };
    }, [source, query, search]);
    return {
        ...state, search, setSearch,
        hasMore: (query.page + 1) * PAGE_SIZE < state.total,
        loadMore: () => {
            if (pending.current || state.error || (query.page + 1) * PAGE_SIZE >= state.total) return;
            pending.current = true;
            setQuery(previous => ({ ...previous, page: previous.page + 1 }));
        },
        retry: () => setQuery(previous => ({ ...previous, attempt: previous.attempt + 1 })),
    };
}
